import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/sif/drob/bolezenRezultatTesta";

const initialState = {
  bolezenRezultatTestaDtoList: [],
  negativno: null, // BolezenRezultatTestaDto
  pozitivno: null, // BolezenRezultatTestaDto
  niOpravljeno: null,
  isLoading: false,
  error: null,
};

/**
 * GET /api/sif/bolezen_rezultat_testa
 */
export const fetchBloodTestResultCodeList = createAsyncThunk(
  "bloodTestResultCodeLists/fetchAll",
  async (_, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(baseUrl);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const bloodTestResultCodeListSlice = createSlice({
  name: "bloodTestResultCodeLists",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchBloodTestResultCodeList.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(fetchBloodTestResultCodeList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.bolezenRezultatTestaDtoList = action.payload;
      state.negativno = action.payload?.find((item) =>
        item.naziv?.key?.includes("NEGATIVEN")
      );
      state.pozitivno = action.payload?.find((item) =>
        item.naziv?.key?.includes("POZITIVEN")
      );
      state.niOpravljeno = action.payload?.find((item) =>
        item.naziv?.key?.includes("NI_OPRAVLJEN")
      );
    });
    builder.addCase(fetchBloodTestResultCodeList.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default bloodTestResultCodeListSlice.reducer;
